export default "__VITE_ASSET__BLDyv714__"